import React, { useState, useEffect } from "react";
import axios from "axios";
import BookingForm from "./Booking/BookingForm";
import { FaAngleLeft } from "react-icons/fa";
import Lottie from "lottie-react";
import loadingAnimation from "../lotties/lf30_editor_omxjejge";
import doneAnimation from "../lotties/lf30_editor_w2yuvjug";

const SITE_KEY = "6LfDOQkkAAAAABD2AVD9WiI9assWC6KaT_tt1ZMC";

const RightSide = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [didSubmit, setDidSubmit] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const loadScriptByURL = (id, url) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        document.body.appendChild(script);
      }
    };
    loadScriptByURL(
      "recaptcha-key",
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`
    );
  }, []);

  const handleOnClick = (bookingData) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: "submit" }).then(() => {
        submitOrderHandler(bookingData);
      });
    });
  };

  const submitOrderHandler = async (bookingData) => {
    try {
      setIsSubmitting(true);
      const cors = 'https://corsanywhere.herokuapp.com/'
      await axios.post(cors + "https://api.tarabezah.com/v1/External/Insert", {
        ...bookingData,
      }, {
        mode: 'cors',
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Credentials": true,
          cors: "*"
        }
      });
      setIsSubmitting(false);
      setDidSubmit(true);
    } catch (error) {
      setIsError(true);
      setIsSubmitting(false);
      setDidSubmit(false);
    }
  };

  const bookAgainHandler = () => {
    setIsError(false);
    setIsSubmitting(false);
    setDidSubmit(false);
  };

  const bookingFormContent = (
    <div className="p-4 max-w-[600px] m-auto">
      <h1 className="text-xl font-medium">Enter Your Booking Details:</h1>
      <BookingForm onConfirm={handleOnClick} />
    </div>
  );

  const isSubmittingContent = (
    <div className="p-4 max-w-[600px] m-auto">
      <Lottie animationData={loadingAnimation} loop={true} />
      <h3 className="text-center text-xl">Loading...</h3>
    </div>
  );

  const didSubmitModalContent = (
    <div className="p-4 max-w-[600px] m-auto">
      <Lottie animationData={doneAnimation} loop={false} />
      <h3 className="text-center text-xl">Successfully Sent!</h3>
      <p className="text-center text-base pb-4">
        Looking Forward to Seeing You
      </p>
      <button
        onClick={bookAgainHandler}
        className="transition duration-300 text-white text-center py-3 px-4 bg-[#0094b5] mx-auto block rounded-sm text-md hover:bg-[#007690] hover:transition"
      >
        Book Again
      </button>
    </div>
  );

  const errorModel = (
    <div className="p-4 max-w-[600px] m-auto">
      <h3 className="text-center text-xl pb-4">Something Went Wrong!</h3>
      <button
        onClick={bookAgainHandler}
        className="transition duration-300 text-white text-center py-3 px-4 bg-[#0094b5] mx-auto block rounded-sm text-md hover:bg-[#007690] hover:transition"
      >
        Try Again
      </button>
    </div>
  );

  return (
    <div className="flex-1 content-right">
      <a href="http://narbeachcafe.com/">
        <button className="transition duration-300 text-white text-center py-3 px-4 bg-[#0094b5] my-5 mr-5 ml-auto block rounded-sm text-md hover:bg-[#007690] hover:transition">
          <FaAngleLeft className="inline align-[-2px]" /> Back to Home
        </button>
      </a>
      {!isSubmitting && !didSubmit && !isError && bookingFormContent}
      {isSubmitting && !didSubmit && !isError && isSubmittingContent}
      {!isSubmitting && didSubmit && !isError && didSubmitModalContent}
      {!isSubmitting && !didSubmit && isError && errorModel}
    </div>
  );
};

export default RightSide;
